import { gql } from 'graphql-tag'

export const USER_CARD_USER = gql`
    fragment UserCardUser on user {
        id
        virtual_avatar_url
        virtual_display_name
        virtual_progression_points
    }
`
